import { render, staticRenderFns } from "./CbsRecordForm_old.vue?vue&type=template&id=0209655e&scoped=true"
import script from "./CbsRecordForm_old.vue?vue&type=script&lang=js"
export * from "./CbsRecordForm_old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0209655e",
  null
  
)

export default component.exports